export default __webpack_public_path__ + "static/media/tuner.f96c3cee.svg";